import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * AdminRoute Component
 * Protege rutas que solo deben ser accesibles para usuarios con role='admin'
 * 
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Componentes hijos que se renderizarán si el usuario es admin
 * @returns {React.ReactNode} - Renderiza los children si es admin, redirige a /epl/labs si no
 */
const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading, user } = useAuth();

  // 🐛 DEBUG: Logs para verificar el estado
  console.log('🔐 AdminRoute - Debug:', {
    isAuthenticated,
    isAdmin,
    loading,
    userRole: user?.role,
    user: user
  });

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verificando permisos...</p>
        </div>
      </div>
    );
  }

  // Si no está autenticado, redirigir a login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si está autenticado pero no es admin, redirigir a labs públicos
  if (!isAdmin) {
    return <Navigate to="/epl/labs" replace />;
  }

  // Usuario es admin, renderizar children
  return <>{children}</>;
};

export default AdminRoute;
